import { FC, useEffect, useState } from "react";

import { Button, Stack } from "@mui/material";

import ArrayValueComponent from "./ArrayValueComponent";

export interface ArrayValue {
    value: string;
}

interface ArrayPropertyComponentProps {
    array: string[];
    changeArray: (value: string[]) => void;
}

const ArrayPropertyComponent: FC<ArrayPropertyComponentProps> = ({ array, changeArray }) => {
    const [values, setValues] = useState<ArrayValue[]>([]);

    useEffect(() => {
        const temp: ArrayValue[] = [];
        for (let i = 0; i < array.length; i++) {
            temp.push({ value: array[i] });
        }

        setValues(temp);
    }, [array])

    function AddValue() {
        const newArray: ArrayValue[] = [...values, { value: "" }];
        setValues(newArray);
        changeArray(newArray.map((item) => item.value));
    }

    function ArrayChanged() {
        changeArray(values.map((item) => item.value))
    }

    return (
        <Stack>
            {values.map((value, index) =>
                <ArrayValueComponent
                    key={index}
                    value={value}
                    arrayChanged={ArrayChanged} />
            )}

            <Button
                variant="outlined"
                onClick={() => AddValue()}
                sx={{ width: '82px', marginLeft: "10px" }}>
                Add
            </Button>
        </Stack>
    )
}

export default ArrayPropertyComponent;